import { useQuery, UseQueryResult } from 'react-query';
import { AppointmentCoachRoleAutoComplete, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseAutoCompleteAppointmentCoachRolesProps {
  search: string;
}

function useAutoCompleteAppointmentCoachRoles({
  search,
}: IUseAutoCompleteAppointmentCoachRolesProps): UseQueryResult<{
  data: Array<AppointmentCoachRoleAutoComplete>;
}> {
  const params: UrlParams = {};
  if (search) {
    params.search = search;
  }

  return useQuery(['appointment-coach-roles-autocomplete', search], () =>
    client.get(`appointment-coach-roles/auto-complete/?${encodeUrlParams(params)}`),
  );
}

export default useAutoCompleteAppointmentCoachRoles;
